import * as React from 'react';
import * as styles from './Breadcrumbs.css';
import { clsx } from 'clsx';

interface IBreadcrumbsProps {
  withBackground?: boolean;
}

export const Breadcrumbs: React.FC<React.PropsWithChildren<IBreadcrumbsProps>> = ({ children, withBackground }) => {
  return <div className={clsx(styles['container'], withBackground && [styles['container--gray']])}>{children}</div>;
};
